import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import LoadingButton from "Components/Button/LoadingButton";

const EXPORT_TYPES = [
    { value: "png", label: "PNG (Poids plus lourd, qualité supérieure)" },
    { value: "jpg", label: "JPG (Poids réduit, qualité standard)" },
    { value: "pdf", label: "PDF" },
    { value: "html", label: "HTML" },
];

const QUALITY_OPTIONS = [
    { value: "normal", label: "Normale" },
    { value: "high", label: "Élevée" },
];

interface DownloadModalProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (data: { exporterType: string; pixel: number; quality: string; }) => void;
    isLoading: boolean;
}

const DownloadModal: React.FC<DownloadModalProps> = ({ show, onHide, onSubmit, isLoading }) => {
    const [exporterType, setExporterType] = useState("png");
    const [pixel, setPixel] = useState(600);
    const [quality, setQuality] = useState("normal");

    return (
        <Modal show={show} onHide={onHide} size="sm" centered>
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold">
                    Export de l'édition
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4">
                <div className="row">
                    <div className="col-12">
                        <label className="form-label fw-semibold">Exporter l'édition en</label>
                        <Form.Select value={exporterType} onChange={(e) => setExporterType(e.target.value)}>
                            {EXPORT_TYPES.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>

                <hr />

                <div className="mb-4">
                    <div className="col-12">
                            <label className="form-label fw-semibold">Largeur de l'image en pixels</label>
                            <Form.Control type="number" value={pixel} onChange={(e) => setPixel(Number(e.target.value))} />
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-6">
                        <label className="form-label fw-semibold">Qualité de l'image</label>
                        <div className="d-flex gap-4 mt-2">
                            {QUALITY_OPTIONS.map((opt) => (
                                <Form.Check
                                    key={opt.value}
                                    type="radio"
                                    label={opt.label}
                                    name="quality"
                                    value={opt.value}
                                    checked={quality === opt.value}
                                    onChange={(e) => setQuality(e.target.value)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="px-4">
                <Button variant="link" className="text-muted px-3" onClick={onHide}>
                    Annuler
                </Button>
                <LoadingButton variant="primary" isLoading={isLoading} onClick={() => onSubmit({ exporterType, pixel, quality })}>
                    Exporter
                </LoadingButton>
            </Modal.Footer>
        </Modal>
    );
};

export default DownloadModal;
